import {
  Avatar,
  Fab,
  Fade,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Slide,
  FormLabel,
  TextField,
  Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import DeleteIcon from '@material-ui/icons/Delete';
import Edit from '@material-ui/icons/Edit';
import Mail from '@material-ui/icons/MailOutline';
import ReplayIcon from '@material-ui/icons/Replay';
import Search from '@material-ui/icons/Search';
import VisibilityIcon from '@material-ui/icons/Visibility';
import classnames from 'classnames';
import { format, isAfter, subMonths, parse } from 'date-fns';
import MUIDataTable from 'mui-datatables';
import React from 'react';
import { Link } from 'react-router-dom';
import { withAplicacao } from '../../contexts/AplicacaoContext';
import AlertDialogSlide from '../share/AlertDialogSlide';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import LongMenu from '../share/LongMenu';
import VariantSnackbar from '../share/VariantSnackbar';
import DialogErrosDemonstrativos from './DialogErrosDemonstrativos';
import ToolbarNovo from './ToolbarNovo';
import ToolbarAuxilioSaudeSelect from './ToolbarAuxilioSaudeSelect';
import FilterServidorSemVinculo from '../share/FilterServidorSemVinculo';
import FormDialogAuxilioSaude from './FormDialogAuxilioSaude';
import AuxilioSaudeApi from '../../api/AuxilioSaudeApi';

const styles = theme => ({
  searchIcon: {
    marginRight: theme.spacing(1),
  },
  button: {
    margin: theme.spacing(1),
    marginRight: theme.spacing(10),
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
  link: {
    textDecoration: 'none',
  },
  body: {
    backgroundColor: '#EDEDEE',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  fontTable: {
    fontSize: 12
  },
  avatar: {
    marginLeft: '20px',
    fontSize: 12
  },
  formControlAutoCompleteBenef: {
    margin: theme.spacing(1),
    minWidth: 300,
  },
  selectEstado: {
    margin: theme.spacing(1),
    width: 250,
  },
  formControlAutoCompleteProtocolo: {
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(1),
    width: 205,
  },
  textField: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(2),
    width: 200,
  },
  tableRowProcessado: {
    backgroundColor: 'rgb(223, 240, 216)',
  },
  tableRowCancelado: {
    backgroundColor: '#f2dede',
  },
  tableRowAnalisado: {
    backgroundColor: '#d0edf4',
  },
  iconButton: {
    marginBottom: theme.spacing(1),
  },
  mesRef: {
    marginLeft: theme.spacing(3),
    marginBottom: theme.spacing(1)
  },
});

const nomeMes = ['-', 'JAN','FEV','MAR','ABR','MAI','JUN','JUL','AGO','SET','OUT','NOV', 'DEZ'];

class AuxilioSaude extends React.Component {
  auxilioSaudeApi = new AuxilioSaudeApi();
  state = {
    auxilios: [],
    nomesServidores: [],
    estadoAuxilio: 0,
    codigoSelected: '',
    nomeServidorSelected: '',
    fetching: false,
    fetchingInicio: true,
    estados: [],
    numProtocoloSelected: 0,
    seqEstadoSelected: 0,
    codProcessoSeiSelected: 0,
    codServidorSelected: 0,
    seqDependenteSelected: 0,
    from: format(subMonths(new Date(), 12), 'YYYY-MM-DD'),
    to: format(new Date(), 'YYYY-MM-DD'),
    auxilioSelecionado: {},
    isEditavel: true,
    modoInclusao: true,
    modoCancelamento: true,
    tituloFormDialog: '',
    snackOpen: false,
    snackVariant: 'success',
    snackHorizontal: 'right',
    snackMessage: '',
    openDialog: false,
    openDialogValidacao: false,
    openDialogHomologar: false,
    openDialogExclusao: false,
    dialogTitle: '',
    dialogContent: '',
    dialogTitleHomologar: '',
    dialogMessageHomologar: '',
    dialogMessageExclusao: '',
    openDialogDesfazerHomologacao: false,
    dialogTitleDesfazerHomologacao: '',
    dialogMessageDesfazerHomologacao: '',
    sucesso: true,
    anchorEl: null,
    auxiliosSemErros: [],
    datasDeReferencia: [],
    mesAno: 'Todas',
  }
  getListaDatasReferencia () {
    let dataInicial = new Date(2023, 1, 1);
    let dataAtual = new Date();
    let resultado = [];
    resultado.push('Todas');
    while (isAfter(dataAtual, dataInicial)) {
      let registro = format(new Date(dataAtual), 'MM/YYYY');
      resultado.push(registro);
      dataAtual = subMonths(dataAtual, 1);
    }
    this.setState({datasDeReferencia: resultado});
  }

  componentDidMount = async () => {
    await this.consultarNomesServidoresSemVinculo();
    await this.consultarEstados();
    this.getListaDatasReferencia();
    this.setState({fetchingInicio: false});
  }

  consultarEstados = async () => {
    let estados = await this.props.getEstadosAuxilio();
    this.setState({ estados: estados });
  }

  consultarNomesServidoresSemVinculo = async () => {
    const nomesServidores = await this.props.getNomesServidoresSemVinculo();
    this.setState({ nomesServidores: nomesServidores });
  }

  handleClickBuscar = async () => {
    this.setState({auxilios: [], fetching: true});
    const filtro = {
      numProtocolo: this.state.numProtocoloSelected,
      codServidor: this.state.codServidorSelected,
      seqDependente: this.state.seqDependenteSelected,
      codEstado: this.state.seqEstadoSelected,
      dataInicial: this.state.from === '' ? parse(new Date(0)) : parse(this.state.from),
      dataFinal: this.state.to === '' ? parse(new Date(0)) : parse(this.state.to),
      mes: this.state.mesAno === 'Todas' ? 0 : Number(this.state.mesAno.substring(0, 2)),
      ano: this.state.mesAno === 'Todas' ? 0 : Number(this.state.mesAno.substring(3, 7)),
    };
    await this.consultarAuxilios(filtro);
    this.setState({fetching: false});
  }
  consultarAuxilios = async (filtro) => {
    this.setState({auxilios: [], fetching: true});
    const auxilios = await this.auxilioSaudeApi.consultarAuxilios(filtro.numProtocolo, filtro.codServidor, filtro.seqDependente, filtro.codEstado, filtro.dataInicial, filtro.dataFinal, filtro.mes, filtro.ano);
    this.setState({ auxilios: auxilios, fetching: false });
  }

  handleClickLimpar = async () => {
    this.setState({
      estadoProtocolo: 0,
      codigoSelected: '',
      nomeServidorSelected: '',
      codServidorSelected: 0,
      seqDependenteSelected: 0,
    });
  }

  handleSelectBeneficiario = (codigo, nome) => {
    this.setState({
      codigoSelected: codigo,
      nomeServidorSelected: nome,
      codServidorSelected: Number(codigo.substring(0, 5)),
      seqDependenteSelected: Number(codigo.substring(6, 8)),
    });
  }

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  handleClickIncluir = () => {
    this.setState({openDialog: true, tituloFormDialog: 'Inclusão de Auxílio', auxilioSelecionado: {}, modoInclusao: true, isEditavel: true});
  }

  handleDialogClose = async () => {
    this.setState({openDialog: false});
  };

  incluirAuxilio = async (auxilio) => {
    this.setState({fetching: true, auxilioSelecionado: {}});
    const result = await this.auxilioSaudeApi.incluirAuxilio(auxilio);
    if (result !== undefined && result.data !== undefined && result.data.codigoRetorno === 1) {
      this.setState({numProtocoloSelected: Number(result.data.registrosSemErros[0])});
    } else {
      this.setState({numProtocoloSelected: 0});
    }
    await this.onOperacaoFinalizadaIncluirAlterar(result);
  }

  alterarAuxilio = async (auxilio) => {
    this.setState({fetching: true, auxilioSelecionado: {}});
    const result = await this.auxilioSaudeApi.alterarAuxilio(auxilio);
    if (result !== undefined && result.data !== undefined && result.data.codigoRetorno === 1) {
      this.setState({numProtocoloSelected: Number(result.data.registrosSemErros[0])});
    } else {
      this.setState({numProtocoloSelected: 0});
    }
    await this.onOperacaoFinalizadaIncluirAlterar(result);
  }

  homologarAuxilio = async () => {
    this.setState({fetching: true});
    await this.auxilioSaudeApi.homologarAuxilio(this.state.auxilioSelecionado.numProtocolo);
    await this.onOperacaoFinalizada('Auxílio homologado com sucesso!');
  }
  desfazerHomologacaoAuxilio = async () => {
    this.setState({fetching: true});
    await this.auxilioSaudeApi.desfazerHomologacaoAuxilio(this.state.auxilioSelecionado.numProtocolo);
    await this.onOperacaoFinalizada('Homologação do auxílio desfeita com sucesso!');
  }

  excluirAuxilio = async () => {
    this.setState({fetching: true});
    await this.auxilioSaudeApi.excluirAuxilio(this.state.auxilioSelecionado.numProtocolo);
    await this.onOperacaoFinalizada('Auxílio excluído com sucesso!');
  }

  onOperacaoFinalizada = async (msg) => {
    this.setState({fetching: false, snackOpen: true, snackMessage: msg, sucesso: true});
    const filtro = {
      numProtocolo: this.state.numProtocoloSelected === undefined || this.state.numProtocoloSelected === '' ? 0 : this.state.numProtocoloSelected,
      codServidor: this.state.codServidorSelected !== '' ? this.state.codServidorSelected : 0,
      seqDependente: this.state.seqDependenteSelected !== '' ? this.state.seqDependenteSelected : 0,
      codEstado: this.state.seqEstadoSelected,
      dataInicial: this.state.from === '' ? parse(new Date(0)) : parse(this.state.from),
      dataFinal: this.state.to === '' ? parse(new Date(0)) : parse(this.state.to),
      mes: this.state.mesAno === 'Todas' ? 0 : Number(this.state.mesAno.substring(0, 2)),
      ano: this.state.mesAno === 'Todas' ? 0 : Number(this.state.mesAno.substring(3, 7)),
    };
    await this.consultarAuxilios(filtro);
  }

  onOperacaoFinalizadaIncluirAlterar = async (result) => {
    if (result === undefined || result.data === undefined) {
      this.setState({
        snackOpen: true,
        snackMessage: 'Não foi possível realizar a operação. Favor tentar novamente.',
        fetching: false,
        openDialog: false,
        sucesso: false});
    } else {
      if (result.data.codigoRetorno === 1) {
        this.setState({ snackOpen: true,
          snackMessage: result.data.msgRetornoResumida,
          sucesso: true,
          fetching: false,
          openDialog: false });
        event.preventDefault();
        const filtro = {
          numProtocolo: this.state.numProtocoloSelected === undefined || this.state.numProtocoloSelected === '' ? 0 : this.state.numProtocoloSelected,
          codServidor: this.state.codServidorSelected !== '' ? this.state.codServidorSelected : 0,
          seqDependente: this.state.seqDependenteSelected !== '' ? this.state.seqDependenteSelected : 0,
          codEstado: this.state.seqEstadoSelected,
          dataInicial: this.state.from === '' ? parse(new Date(0)) : parse(this.state.from),
          dataFinal: this.state.to === '' ? parse(new Date(0)) : parse(this.state.to),
          mes: this.state.mesAno === 'Todas' ? 0 : Number(this.state.mesAno.substring(0, 2)),
          ano: this.state.mesAno === 'Todas' ? 0 : Number(this.state.mesAno.substring(3, 7)),
            };
        await this.consultarAuxilios(filtro);
        this.setState({numProtocoloSelected: 0});
      } else {
        this.setState({
          openDialogValidacao: true,
          openDialog: false,
          dialogContent: result.data.registrosComErros,
          dialogTitle: result.data.msgRetornoResumida,
          registrosSemErros: result.data.registrosSemErros,
          fetching: false});
      }
    }
  }

  onOperacaoFinalizadaSelect = async (result) => {
    if (result === undefined || result === null) {
      this.setState({snackOpen: true, snackMessage: 'Não foi possível realizar a operação.', fetching: false, sucesso: false});
    } else {
      this.setState({openDialogValidacao: true,
        dialogContent: result.registrosComErros,
        dialogTitle: result.msgRetornoResumida,
        auxiliosSemErros: result.registrosSemErros,
        fetching: false,
        sucesso: false});
    }
    const filtro = {
      numProtocolo: this.state.numProtocoloSelected === undefined || this.state.numProtocoloSelected === '' ? 0 : this.state.numProtocoloSelected,
      codServidor: this.state.codServidorSelected !== '' ? this.state.codServidorSelected : 0,
      seqDependente: this.state.seqDependenteSelected !== '' ? this.state.seqDependenteSelected : 0,
      codEstado: this.state.seqEstadoSelected,
      dataInicial: this.state.from === '' ? parse(new Date(0)) : parse(this.state.from),
      dataFinal: this.state.to === '' ? parse(new Date(0)) : parse(this.state.to),
      mes: this.state.mesAno === 'Todas' ? 0 : Number(this.state.mesAno.substring(0, 2)),
      ano: this.state.mesAno === 'Todas' ? 0 : Number(this.state.mesAno.substring(3, 7)),
    };
    await this.consultarAuxilios(filtro);
  }
  handleChangeSelect = event => {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  }

  handleCloseDialogValidacao = () => {
    this.setState({ openDialogValidacao: false });
  };

  handleCloseDialogHomologar = () => {
    this.setState({ openDialogHomologar: false });
  };

  handleDialogConfirmHomologar = async () => {
    this.setState({ openDialogHomologar: false, fetching: true });
    await this.homologarAuxilio();
  }

  handleCloseDialogDesfazerHomologacao = () => {
    this.setState({ openDialogDesfazerHomologacao: false });
  };

  handleDialogConfirmDesfazerHomologacao = async () => {
    this.setState({ openDialogDesfazerHomologacao: false, fetching: true });
    await this.desfazerHomologacaoAuxilio();
  }

  handleCloseDialogExcluir = () => {
    this.setState({ openDialogExclusao: false });
  };

  handleDialogConfirmExcluir = async () => {
    this.setState({ openDialogExclusao: false, fetching: true });
    await this.excluirAuxilio();
  }

  handleClickToolBar = () => {
    this.setState({ fetching: true });
  }

  handleClickHomologar = (event, tableMeta) => {
    const auxilioSelecionado = {
      numProtocolo: this.state.auxilios[tableMeta.rowIndex][0],
    };
    this.setState({openDialogHomologar: true, 
      dialogTitleHomologar: 'Marcar Auxílio como homologado - ' + auxilioSelecionado.numProtocolo, 
      dialogMessageHomologar: 'Deseja marcar este Auxílio como homologado? O estado será alterado para HOMOLOGADO, AGUARDANDO PAGAMENTO', 
      auxilioSelecionado: auxilioSelecionado});
  }
  handleClickDesfazerHomologacao = (event, tableMeta) => {
    const auxilioSelecionado = {
      numProtocolo: this.state.auxilios[tableMeta.rowIndex][0],
    };
    this.setState({openDialogDesfazerHomologacao: true, 
      dialogTitleDesfazerHomologacao: 'Marcar Auxílio como NÃO ANALISADO - ' + auxilioSelecionado.numProtocolo, 
      dialogMessageDesfazerHomologacao: 'Deseja marcar este Auxílio como NÃO ANALISADO?', 
      auxilioSelecionado: auxilioSelecionado});
  }

  handleClickMenu = (event, tableMeta) => {
    const nf = new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    const auxilioSelecionado = {
      numProtocolo: this.state.auxilios[tableMeta.rowIndex][0],
      codServidor: this.state.auxilios[tableMeta.rowIndex][1],
      seqDependente: this.state.auxilios[tableMeta.rowIndex][2],
      nomeBeneficiario: this.state.auxilios[tableMeta.rowIndex][3],
      valPago: this.state.auxilios[tableMeta.rowIndex][4] === null ? undefined : nf.format(this.state.auxilios[tableMeta.rowIndex][4]),
      valReferencia: this.state.auxilios[tableMeta.rowIndex][5] === null ? undefined : nf.format(this.state.auxilios[tableMeta.rowIndex][5]),
      valAuxilio: this.state.auxilios[tableMeta.rowIndex][6] === null ? undefined : nf.format(this.state.auxilios[tableMeta.rowIndex][6]),
      codEstado: this.state.auxilios[tableMeta.rowIndex][7],
      desEstado: this.state.auxilios[tableMeta.rowIndex][8],
      txtObservacao: this.state.auxilios[tableMeta.rowIndex][9],
      dtaCadastro: this.state.auxilios[tableMeta.rowIndex][10],
      dtaReferencia: this.state.auxilios[tableMeta.rowIndex][11],
      mesPagto: this.state.auxilios[tableMeta.rowIndex][12],
      anoPagto: this.state.auxilios[tableMeta.rowIndex][13],
      txtProcessoSei: this.state.auxilios[tableMeta.rowIndex][16],
      dtaProcessamento: this.state.auxilios[tableMeta.rowIndex][17],
      numMatricula: this.state.auxilios[tableMeta.rowIndex][1] + '-' + (this.state.auxilios[tableMeta.rowIndex][2] === 0 ? '00' : this.pad(this.state.auxilios[tableMeta.rowIndex][2], 2)),
    };
    this.setState({ anchorEl: event.currentTarget, auxilioSelecionado: auxilioSelecionado });
  }
  pad (str, max) {
    str = str.toString();
    return str.length < max ? this.pad('0' + str, max) : str;
  }

  handleCloseMenu = () => {
    this.setState({ anchorEl: null });
  }

  handleChangeMenu = (index) => {
    this.setState({anchorEl: null});
    if (index === 0) {
      if (this.state.auxilioSelecionado.codEstado !== 3) {
        this.setState({openDialogExclusao: true, tituloFormDialog: 'Exclusão de Auxílio - Protocolo ' + this.state.auxilioSelecionado.numProtocolo, dialogMessageExclusao: 'Deseja excluir este auxílio?'});
      } else {
        this.setState({snackOpen: true, snackMessage: 'Não foi possível excluir este Auxílio pois este já foi homologado.', fetching: false, sucesso: false});
      }
    }
    if (index === 1) {
      if (this.state.auxilioSelecionado.codEstado === 1 || this.state.auxilioSelecionado.codEstado === 2) {
        this.setState({openDialog: true, tituloFormDialog: 'Alteração de Auxílio - ' + this.state.auxilioSelecionado.numProtocolo, modoInclusao: false, isEditavel: true});
      } else {
        this.setState({snackOpen: true, snackMessage: 'Não foi possível alterar este Auxílio pois este já foi homologado ou está cancelado.', fetching: false, sucesso: false});
      }
    }
    if (index === 2) {
      this.setState({openDialog: true, tituloFormDialog: 'Visualizar auxílio - ' + this.state.auxilioSelecionado.numProtocolo, modoInclusao: false, isEditavel: false});
    }
  }

  render () {
    const options = {
      customToolbar: () => (
        <ToolbarNovo
          handleClickIncluir={this.handleClickIncluir}
        />
      ),
      customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
        <ToolbarAuxilioSaudeSelect
          selectedRows={selectedRows}
          displayData={displayData}
          setSelectedRows={setSelectedRows}
          handleClickToolBar={this.handleClickToolBar}
          onOperacaoFinalizada={this.onOperacaoFinalizadaSelect}
        />
      ),
      isRowSelectable: (dataIndex) => {
        return this.state.auxilios[dataIndex][7] === 1;
      },
      setRowProps: (row) => {
        return {
          title: row[7] === 3 ? 'Apenas auxílios que não estejam no estado PAGAMENTO EFETUADO podem ser excluídos ou alterados.' : 
          row[7] === 1 ? 'Para homologar este registro, favor selecioná-lo e clicar no botão Homologar Auxílio.' : '',
          className: classnames(
            {
              [this.props.classes.tableRowAnalisado]: row[7] === 2,
              [this.props.classes.tableRowProcessado]: row[7] === 3,
            }, this.props.classes.tableRow),
        };
      },

      print: false,
      download: false,
      filterType: 'dropdown',
      selectableRows: 'multiple',
      rowsPerPageOptions: [5, 10, 15],
      rowsPerPage: 10,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
          viewColumns: 'Ver Colunas',
          filterTable: 'Filtrar',
        },
        filter: {
          all: 'Todos',
          title: 'FILTROS',
          reset: 'RESET',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline'}}>registro(s) selecionado(s)</Typography>,
        },
      }
    };
    const columns = [
      {
        name: 'Protocolo',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Código Servidor',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Código Dependente',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography>{value === 0 ? '-' : value}</Typography>;
          },
        }
      },
      {
        name: 'Nome',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography>{value}</Typography>;
          },
        }
      },
      {
        name: 'Valor Pago',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'Valor Referência',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'Valor Auxílio',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'codEstado',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Estado',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography>{value}</Typography>;
          },
        }
      },
      {
        name: 'txtObservacao',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Data Cadastro',
        options: {
          display: 'excluded',
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value !== null ? <Typography style={{fontSize: 12}}>{format(new Date(value), 'DD/MM/YYYY')}</Typography> : '-';
          },
        }
      },
      {
        name: 'Data Referência',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value !== null ? <Typography>{format(new Date(value), 'DD/MM/YYYY')}</Typography> : '-';
          },
        }
      },
      {
        name: 'Mês Pagto.',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography>{nomeMes[value]}</Typography>;
          },
        }
      },
      {
        name: 'Ano Pagto.',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography>{value === 0 ? '-' : value}</Typography>;
          },
        },
      },
      {
        name: 'Homologar',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            return (
              value === 'HOMOLOGAR'
                ? <IconButton
                  id={'menuButton'}
                  className={classes.iconButton}
                  aria-label='More'
                  aria-owns={open ? 'long-menu' : null}
                  aria-haspopup='true'
                  title={'Alterar estado para HOMOLOGADO, AGUARDANDO PAGAMENTO'}
                  onClick={event => this.handleClickHomologar(event, tableMeta)}
                >
                  <Mail fontSize='medium' />
                </IconButton>
                : value === 'DESFAZER'
                ? <IconButton
                  id={'menuButton'}
                  className={classes.iconButton}
                  aria-label='More'
                  aria-owns={open ? 'long-menu' : null}
                  aria-haspopup='true'
                  title={'Desfazer a Homologação'}
                  onClick={event => this.handleClickDesfazerHomologacao(event, tableMeta)}
                >
                  <ReplayIcon fontSize='medium' />
                </IconButton>
                : '-'
          );
          },
        }
      },
      {
        name: 'Ações',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            let options = [
              {
                index: 0,
                icon: <DeleteIcon />,
                primaryText: 'Excluir Auxílio...',
                visible: true,
                disabled: false
              },
              {
                index: 1,
                icon: <Edit />,
                primaryText: 'Alterar Auxílio...',
                visible: true,
                disabled: false
              },
              {
                index: 2,
                icon: <VisibilityIcon />,
                primaryText: 'Ver Detalhes...',
                visible: true,
                disabled: false
              },
            ];
            return (
              <LongMenu
                menuOptions={options}
                anchorEl={this.state.anchorEl}
                handleClick={this.handleClickMenu}
                handleChange={this.handleChangeMenu}
                handleClose={this.handleCloseMenu}
                selectedItem={tableMeta} />
            );
          },
        }
      },
      {
        name: 'Processo SEI',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Data Processamento',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
    ];
    const { classes } = this.props;
    const { fetching, fetchingInicio, auxilios,
      estados, seqEstadoSelected,
      from, to, mesAno, datasDeReferencia } = this.state;
    return (
      <React.Fragment>
        <Link to='/financeiro' className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='h5'>Auxílios de Saúde</Typography>
              <Avatar className={classes.avatar}>{auxilios.length}</Avatar>
            </Paper>
          </Slide>
        </Link>
        {fetchingInicio ? <LinearProgressBlockScreen />
          : <Paper className={classes.body} elevation={1}>
            <FormControl component='fieldset' className={classes.formControlAutoCompleteBenef}>
              <FilterServidorSemVinculo
                beneficiarios={this.state.nomesServidores}
                handleSelectBeneficiario={this.handleSelectBeneficiario}
                handleClickLimpar={this.handleClickLimpar} />
            </FormControl>
            <FormControl className={classes.selectEstado}>
              <InputLabel shrink htmlFor='tipo-simple'>
                Estado
              </InputLabel>
              <Select
                className={classes.selectEstado}
                value={seqEstadoSelected}
                onChange={this.handleChange}
                inputProps={{
                  name: 'seqEstadoSelected',
                }}
              >
                <MenuItem key={0} value={0}>TODOS</MenuItem>
                {estados.map((estado, idx) => {
                  return (<MenuItem key={idx} value={estado.id}>{estado.nome}</MenuItem>);
                })}
              </Select>
            </FormControl>
            <TextField
              id='date'
              label='De'
              type='date'
              value={from}
              onChange={this.handleChange}
              inputProps={{
                name: 'from',
              }}
              className={classes.textField}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id='date'
              label='Até'
              className={classes.textField}
              type='date'
              value={to}
              onChange={this.handleChange}
              inputProps={{
                name: 'to',
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <FormControl>
              <Fab
                variant='extended'
                title='Buscar'
                type='submit'
                onClick={this.handleClickBuscar}
                onTouchStart={this.handleClickBuscar}
                className={classes.button}>
                <Search className={classes.searchIcon} />
                Buscar
              </Fab>
            </FormControl>
            <FormControl component='fieldset' className={classes.mesRef}>
              <FormLabel component='legend'>Data Lancto. Folha</FormLabel>
              <Select
                value={mesAno}
                onChange={this.handleChangeSelect}
                inputProps={{
                  name: 'mesAno',
                }}
              >
                {datasDeReferencia.map(anoRef => {
                  return (<MenuItem key={anoRef} value={anoRef}>{anoRef}</MenuItem>);
                })}
              </Select>
            </FormControl>
          </Paper>
        }
        {fetching ? <LinearProgressBlockScreen />
          : <Fade timeout={1000} in>
            <Paper className={classes.body} elevation={1}>
              <MUIDataTable
                data={auxilios}
                columns={columns}
                options={options}
              />
            </Paper>
          </Fade>}
        {this.state.openDialog &&
          <FormDialogAuxilioSaude
            titulo={this.state.tituloFormDialog}
            auxilio={this.state.auxilioSelecionado}
            nomesBeneficiarios={this.state.nomesServidores}
            open={this.state.openDialog}
            modoInclusao={this.state.modoInclusao}
            isEditavel={this.state.isEditavel}
            handleClose={this.handleDialogClose}
            handleSave={this.state.modoInclusao ? this.incluirAuxilio : this.alterarAuxilio} />}
        <AlertDialogSlide
          open={this.state.openDialogHomologar}
          handleClose={this.handleCloseDialogHomologar}
          handleClick={this.handleDialogConfirmHomologar}
          title={this.state.dialogTitleHomologar}
          message={this.state.dialogMessageHomologar} />
        <AlertDialogSlide
          open={this.state.openDialogDesfazerHomologacao}
          handleClose={this.handleCloseDialogDesfazerHomologacao}
          handleClick={this.handleDialogConfirmDesfazerHomologacao}
          title={this.state.dialogTitleDesfazerHomologacao}
          message={this.state.dialogMessageDesfazerHomologacao} />
        <AlertDialogSlide
          open={this.state.openDialogExclusao}
          handleClose={this.handleCloseDialogExcluir}
          handleClick={this.handleDialogConfirmExcluir}
          title={this.state.tituloFormDialog}
          message={this.state.dialogMessageExclusao} />
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.sucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
        {this.state.openDialogValidacao &&
          <DialogErrosDemonstrativos
            open={this.state.openDialogValidacao}
            handleClose={this.handleCloseDialogValidacao}
            erros={this.state.dialogContent}
            titulo={this.state.dialogTitle}
            demonstrativosSemErros={this.state.auxiliosSemErros}
            nomeEntidade={'Auxílio'}
            mensagemComplementar={'foi(ram) processados(s) com sucesso.'} />
        }
      </React.Fragment>
    );
  }
}
export default withAplicacao(withStyles(styles)(AuxilioSaude));
